<template>
  <div class="home-page">
    
    <van-nav-bar>
      <template #title>
        <van-image src="img/home/logo3.png" width="60"></van-image>
      </template>
    </van-nav-bar>

    <div id="content">
      <div class="banner">
        <swiper class="banner_swiper" :options="bannerSwiperOption">
          <swiper-slide v-for="(v, key) in banners" :key="key">
            <van-image class="banner_img" round :src="v.url">
              <template v-slot:loading>
                <van-loading type="circular" />
              </template>
            </van-image>
          </swiper-slide>
        </swiper>
      </div>

      <div class="content">
        <div class="txt">
          <span> HOT </span>
          <span class="icon">{{ $t('index.title1') }}</span>
        </div>
        <div class="swiper_wrap">
          <div class="swiper" :style="{ width: `calc(${7.75 * xuanfeiList.length}rem)` }">
            <div v-for="item in xuanfeiList" :key="item.id" class="swipe" @click="goDetail(item)">
              <van-image :src="item.img_url[0]"></van-image>
              <div class="swipe-name">{{ item.xuanfei_name }}</div>
              <div class="tip">
                <span>{{ $t('index.tip1') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="txt">{{ $t('index.title2') }}</div>
        <div class="ganeGroup">
          <div class="gameItem" v-for="item in gameList" :key="item.id" @click="goGame(item)">
            <div class="image">
              <van-image   :src="item.ico"></van-image>
            </div>
            <div class="label">{{ item.name }}</div>
          </div>
        </div>
        <div class="txt">{{ $t('index.title3') }}</div>
        <div class="xuanfeiList">
          <div class="row" v-for="item in xuanfeiList" :key="item.id" @click="goDetail(item)">
            <div class="left">
              <van-image :src="item.img_url[0]"></van-image>
              <div>{{ item.xuanfei_name }}</div>
              <div class="tip">
                <span>{{ $t('index.tip2') }}</span>
              </div>
            </div>

            <div class="right">
              <div class="renzheng">
                <div>{{ $t('index.icon1') }}</div>
                <div>{{ $t('index.icon2') }}</div>
              </div>
              <div class="biaoqian">
                <div v-for="(biaoqian, index) in item.type.slice(0, 3)" :key="index">{{ biaoqian.name }}</div>
              </div>
              <div class="xingji">
                <div>
                  <span>{{ $t('index.label1') }}：</span>
                  <van-icon name="star" color="#3de0ff" size="1rem" />
                  <van-icon name="star" color="#3de0ff" size="1rem" />
                  <van-icon name="star" color="#3de0ff" size="1rem" />
                  <van-icon name="star" color="#3de0ff" size="1rem" />
                  <van-icon name="star" color="#3de0ff" size="1rem" />
                </div>
              </div>
              <div class="info">
                <div>{{ item.info }}</div>
              </div>
              <div class="button2">{{ $t('index.button') }}</div>
            </div>
          </div>
        </div>
        <div class="plCard">
          <div class="title">Live Feed</div>
          <swiper class="pl_swiper"  :options="plOption">
            <swiper-slide class="pl_line" v-for="(v, key) in plList" :key="key">{{ v }}</swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: [],
      tuis: [
        {
          id: 1,
          num: '001',
          name: '',
          pic: require("@/assets/imgs/index_pic/1.jpg"),
          avatar: require("@/assets/imgs/index_avatar/11.jpg"),
          sui: '22yo / 165cm / 46kg'
        },
        {
          id: 2,
          num: '002',
          name: '',
          pic: require("@/assets/imgs/index_pic/2.jpg"),
          avatar: require("@/assets/imgs/index_avatar/12.jpg"),
          sui: '26yo / 170cm / 53kg'
        },
        {
          id: 3,
          num: '003',
          name: '',
          pic: require("@/assets/imgs/index_pic/3.jpg"),
          avatar: require("@/assets/imgs/index_avatar/13.jpg"),
          sui: '21yo / 169cm / 51kg'
        },
        {
          id: 4,
          num: '004',
          name: '',
          pic: require("@/assets/imgs/index_pic/4.jpg"),
          avatar: require("@/assets/imgs/index_avatar/14.jpg"),
          sui: '23yo / 165cm / 49kg'
        },
        {
          id: 5,
          num: '005',
          name: '',
          pic: require("@/assets/imgs/index_pic/5.jpg"),
          avatar: require("@/assets/imgs/index_avatar/15.jpg"),
          sui: '25yo / 167cm / 50kg'
        },
        {
          id: 6,
          num: '006',
          name: '',
          pic: require("@/assets/imgs/index_pic/6.jpg"),
          avatar: require("@/assets/imgs/index_avatar/16.jpg"),
          sui: '22yo / 162cm / 47kg'
        },
        {
          id: 7,
          num: '007',
          name: '',
          pic: require("@/assets/imgs/index_pic/7.jpg"),
          avatar: require("@/assets/imgs/index_avatar/17.jpg"),
          sui: '34yo / 170cm / 54kg'
        },
        {
          id: 8,
          num: '008',
          name: '',
          pic: require("@/assets/imgs/index_pic/8.jpg"),
          avatar: require("@/assets/imgs/index_avatar/18.jpg"),
          sui: '30yo / 166cm / 49kg'
        },
        {
          id: 9,
          num: '009',
          name: '',
          pic: require("@/assets/imgs/index_pic/9.jpg"),
          avatar: require("@/assets/imgs/index_avatar/19.jpg"),
          sui: '24yo / 172cm / 52kg'
        },
        {
          id: 10,
          num: '010',
          name: '',
          pic: require("@/assets/imgs/index_pic/10.jpg"),
          avatar: require("@/assets/imgs/index_avatar/20.jpg"),
          sui: '22yo / 168cm / 49kg'
        }
      ],
      bannerSwiperOption: {
        autoplay: true,
      },
      xuanfeiList: [],
      gameList: [],
      plList: [
        'jx***ib has signed up',
        '95***8f has signed up',
        '71***8c completed a match',
        'xf***45 completed a match',
        'rw***32 completed a match',
        '5n***8m completed a match',
        'bv***f3 has signed up',
        '44***uc has signed up',
        'xo***n0 completed a match',
        'xm***19 has signed up',
        'ha***2g completed a match',
        'or***ze completed a match',
        'df***ux completed a match',
        'zb***is completed a match',
        'ud***c3 has signed up',
        'n8***42 has signed up',
        'm3***r8 has signed up',
        'p1***5a has signed up',
        'ab***9e has signed up',
        '0v***dz has signed up',
        'jx***ib has signed up',
        '95***8f has signed up',
        '71***8c completed a match',
        'xf***45 completed a match',
        'rw***32 completed a match',
        '5n***8m completed a match',
        'bv***f3 has signed up',
        '44***uc has signed up',
        'xo***n0 completed a match',
        'xm***19 has signed up'
      ],
      plOption: {
        autoplay: true,
        direction: 'vertical',
        slidesPerView: 5,
        speed: 800,
      }
    }
  },
  computed: {
    swipeWidth() {
      return window.innerWidth * 0.45
    }
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res => {
        this.banners = res.data?.banners || [];
      })

    },

    getXuanfeiList() {
      this.$http({
        method: 'get',
        url: 'xuanfei_list'
      }).then(res => {
        if (res.code === 200) {
          this.xuanfeiList = res.data.data.map(item => {
            item.info = `Height: ${item.height}cm  Size: ${item.bust}  Available Area: ${item.diqu}`
            return item
          })
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },

    goDetail(e) {
      localStorage.setItem('xuanfeiDetail', JSON.stringify(e))
      this.$router.push(`XuanfeiDetail`);
    },

    goGame(e) {
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'/WindowLottery?key='+e.key+"&id="+e.id})
      }
    },

    
    getGameItem(){
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res=>{
        this.gameList = res.data;
      })
    },
  },
  created() {
    this.getBasicConfig();
    this.getGameItem()
    this.getXuanfeiList()
  }
}
</script>


<style lang="less" scoped>
@import '~@/assets/css/theme.less';

.home-page {
  position: relative;
  min-height: 100%;
  background:
    radial-gradient(80% 32% at 100% 0%, rgba(180, 77, 255, 0.22), transparent 55%),
    radial-gradient(60% 28% at 0% 18%, rgba(61, 224, 255, 0.12), transparent 50%),
    @bg-page;
  &::before {
    content: '';
    pointer-events: none;
    position: absolute;
    inset: 0;
    background-image:
      linear-gradient(rgba(61, 224, 255, 0.045) 1px, transparent 1px),
      linear-gradient(90deg, rgba(61, 224, 255, 0.045) 1px, transparent 1px);
    background-size: 1.7rem 1.7rem;
    mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.85), transparent 62%);
  }
}

.home-page .van-nav-bar {
  background: rgba(7, 11, 20, 0.92);
  background-image: none;
  border-bottom: 1px solid rgba(61, 224, 255, 0.28);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  box-shadow: 0 0.35rem 1rem rgba(0, 0, 0, 0.4), inset 0 -1px 0 rgba(180, 77, 255, 0.35);
}

#content{
  position: relative;
  z-index: 1;
  padding-bottom: 4.2rem;
}

.banner {
  padding: 0.8rem 0.8rem 0;
}

.banner_swiper {
  height: 100%;
  width: 100%;
  border-radius: 0.45rem;
  overflow: hidden;
  border: 1px solid rgba(61, 224, 255, 0.35);
  box-shadow: 0 0.7rem 1.6rem rgba(0, 0, 0, 0.4), 0 0 1.2rem rgba(61, 224, 255, 0.16);

  .swiper-slide {
    // border-radius: 1.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 19.375rem;
    width: 100%;
    height: 9.4rem;
    text-align: center;
    font-weight: bold;
    font-size: 0.625rem;
    background-color: #10182c;
    background-position: center;
    background-size: cover;
    color: #ffffff;
  }

  ::v-deep .swiper-container-3d .swiper-slide-shadow-left {
    background-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
  }

  ::v-deep .swiper-container-3d .swiper-slide-shadow-right {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
  }

  .banner_img {
    border-radius: 0;
    width: 100%;
    height: 100%;
  }
}

.content {
  width: auto;
  margin: 0;
  padding: 0 0.8rem;

  .txt {
    font-size: 1.02rem;
    font-weight: 700;
    letter-spacing: 0.04rem;
    color: @text-title;
    margin-top: 1.15rem;
    margin-bottom: 0.6rem;
    display: flex;
    align-items: center;
    text-shadow: 0 0 0.7rem rgba(61, 224, 255, 0.25);
    &::after {
      content: '';
      flex: 1;
      height: 1px;
      margin-left: 0.75rem;
      background: linear-gradient(90deg, rgba(61, 224, 255, 0.75), rgba(180, 77, 255, 0.15), transparent);
    }
    .icon{
      display: inline-block;
      margin-left: .55rem;
      border-radius: 0.2rem;
      background: transparent;
      border: 1px solid rgba(255, 61, 154, 0.7);
      color: #ffd0ea;
      font-weight: 600;
      letter-spacing: 0.04rem;
      padding: .08rem .5rem;
      font-size: 0.78rem;
      box-shadow: 0 0 0.6rem rgba(255, 61, 154, 0.28);
    }
  }


  .swiper_wrap {
    width: auto;
    max-width: none;
    margin-right: -0.8rem;
    padding-right: 0.8rem;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      display: none;
    }

    .swiper {
      display: flex;
      scroll-snap-type: x mandatory;

      .swipe {
        flex-shrink: 0;
        scroll-snap-align: start;
        width: 7.2rem;
        height: auto;
        overflow: hidden;
        margin-right: .55rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        position: relative;
        border-radius: 0.4rem;
        border: 1px solid rgba(61, 224, 255, 0.4);
        background: rgba(10, 16, 32, 0.72);
        box-shadow: 0 0.5rem 1.2rem rgba(0, 0, 0, 0.4), 0 0 0.8rem rgba(61, 224, 255, 0.12);

        ::v-deep .van-image,
        ::v-deep .van-image__img {
          width: 100%;
          height: 8.4rem;
          object-fit: cover;
          border-radius: 0;
        }

        .swipe-name {
          position: relative;
          z-index: 2;
          padding: 0.38rem 0.4rem 0.42rem;
          font-size: 0.78rem;
          font-weight: 600;
          line-height: 1.2;
          color: @text-title;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .tip {

          position: absolute;
          z-index: 9;
          background: @grad-peach;
          color: #fff;
          width: 6.2rem;
          height: 6.2rem;
          transform: rotate(45deg);
          left: 4.55rem;
          top: -3.7rem;

          span {

            position: absolute;
            bottom: 0;
            left: 1.6rem;
            font-size: .76667rem;
            font-weight: 600;
          }
        }
      }
    }
  }

  .xuanfeiList {
      .row {
      display: flex;
      flex-direction: column;
      width: 100%;
      border: 1px solid rgba(140, 190, 255, 0.22);
      border-top: 2px solid @neon-blue;
      background: @glass-bg;
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
      border-radius: 0.45rem;
      box-shadow: @shadow-soft;
      padding: 0;
      margin-bottom: 0.8rem;
      overflow: hidden;

      .left {
        width: 100%;
        height: 9.2rem;
        text-align: left;
        color: #fff;
        position: relative;
        overflow: hidden;
        border-radius: 0;
        flex-shrink: 0;

        ::v-deep .van-image,
        ::v-deep .van-image__img {
          width: 100%;
          height: 9.2rem;
          object-fit: cover;
          border-radius: 0;
        }

        > div:not(.tip) {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 2;
          margin: 0;
          padding: 1.5rem 0.75rem 0.45rem;
          font-size: 0.98rem;
          font-weight: 600;
          line-height: 1.2;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          background: linear-gradient(180deg, rgba(5, 8, 16, 0), rgba(5, 8, 16, 0.9));
        }

        .tip {
          position: absolute;
          transform: rotate(45deg);
          right: -4.4rem;
          width: 6.4rem;
          height: 6.4rem;
          top: -3.5rem;
          background: @grad-peach;
          color: #fff;
          opacity: .95;

          span {
            position: absolute;
            font-weight: 600;
            left: .8rem;
            bottom: 0;
            font-size: .8rem;
          }
        }
      }

      .right {
        flex: none;
        min-width: 0;
        padding: 0.7rem 0.75rem 0.8rem;
        display: flex;
        flex-direction: column;

        .renzheng {
          display: flex;
          flex-wrap: wrap;
          gap: 0.35rem 0.4rem;

          >div {
            background: rgba(61, 224, 255, 0.08);
            border: 1px solid rgba(61, 224, 255, 0.4);
            color: #d8f7ff;
            font-weight: 600;
            margin-left: 0;
            padding: .16rem .4rem;
            font-size: .73333rem;
            border-radius: @radius-pill;
            max-width: 100%;
            white-space: nowrap;
            display: flex;
            align-items: center;

            &::before {
              content: '';
              width: .8125rem;
              height: .8125rem;
              background: url('/public/img/home/icon.png');
              background-size: 100% 100%;
            }
          }
        }

        .biaoqian {
          display: flex;
          flex-wrap: wrap;
          gap: 0.3rem;
          padding: 0.2rem 0 0.1rem;

          div {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: .12rem .38rem;
            margin: 0;
            border-radius: @radius-pill;
            font-size: .72rem;

            &:nth-child(1n) {
              background-color: rgba(255, 61, 154, 0.1);
              color: #ffd0ea;
              border: 1px solid rgba(255, 61, 154, 0.45);
            }

            &:nth-child(2n) {
              background-color: rgba(61, 224, 255, 0.08);
              color: #d7f6ff;
              border: 1px solid rgba(61, 224, 255, 0.4);
            }

            &:nth-child(3n) {
              background-color: rgba(180, 77, 255, 0.12);
              color: #ead7ff;
              border: 1px solid rgba(180, 77, 255, 0.45);
            }
          }
        }

        .xingji {
          color: @text-body;
          font-size: .9rem;
          padding-bottom: .3rem;
        }

        .info {
          overflow: hidden;

          >div {

            font-size: .9rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: @text-sub;
          }
        }

        .button2 {
          text-align: center;
          background: @grad-primary;
          box-shadow: @shadow-pink;
          font-weight: 600;
          letter-spacing: 0.06rem;
          color: #fff;
          border-radius: 0.3rem;
          padding: .4rem 0;
          width: 100%;
          margin: 0.45rem 0 0;
          max-width: none;
        }
      }
    }
  }

  .ganeGroup{
    display: flex;
    flex-wrap: wrap;
    gap: 0.6rem;
    background: transparent;
    padding: 0;
    .gameItem{
      width: calc((100% - 0.6rem) / 2);
      flex: none;
      display: flex;
      flex-direction: row;
      align-items: center;
      text-align: left;
      gap: 0.55rem;
      background: @glass-bg;
      border: 1px solid rgba(61, 224, 255, 0.24);
      border-radius: 0.45rem;
      padding: 0.55rem 0.65rem;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08), 0 0.45rem 1rem rgba(0, 0, 0, 0.32);
    }
    .image{
      width: 3.15rem;
      height: 3.15rem;
      margin: 0;
      flex-shrink: 0;
      border-radius: 0.3rem;
      overflow: hidden;
      ::v-deep .van-image__img {
        object-fit: cover;
      }
    }
    .label{
      flex: 1;
      min-width: 0;
      font-size: 0.88rem;
      line-height: 1.3;
      min-height: 0;
      padding-top: 0;
      font-weight: 600;
      color: @text-title;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .van-image{
      width: 100%;
      height: 100%;
    }
  }

  .plCard{
    width: 100%;
    margin: 1.2rem auto 1.25rem;
    height: 11.25rem;
    padding: 0.7rem 0.9rem;
    background: rgba(8, 14, 28, 0.78);
    border-radius: 0.45rem;
    border: 1px solid rgba(61, 224, 255, 0.28);
    box-shadow: @shadow-soft, inset 0 1px 0 rgba(255, 255, 255, 0.08);
    .title{
      background: @grad-pink-lavender;
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      font-weight: 700;
      letter-spacing: 0.16rem;
      font-size: 1.05rem;
      text-align: left;
      margin-bottom: 0.5rem;
      text-transform: uppercase;
    }
    .pl_swiper{
      height: 7.5rem;
    }
    .pl_line{
      text-align: left;
      color: #d5e4ff;
      height: 1.5rem;
      line-height: 1.5rem;
      font-size: 0.82rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>